
  import { Vue, Component, Prop } from "vue-property-decorator";

  import UIButton from "@/components/button/ui-button.vue";
  import PlusIcon from "@/components/icons/PlusIcon.vue";
  import ActivityFormModal from "@/components/projects/activities/ActivityFormModal.vue";

  @Component({
    components: {
      UIButton,
      PlusIcon,
      ActivityFormModal,
    },
  })
  export default class AddContractorToProject extends Vue {
    @Prop({ type: String, required: true }) readonly companyId!: string;
    @Prop({ type: String, required: true }) readonly currentUserRole!: string;
    @Prop({ type: String, required: true }) readonly contractorId?: string;
    @Prop({ type: String, default: undefined }) readonly buttonSize?: string;
    @Prop({ type: String, default: undefined }) readonly variant?: string;
    @Prop({ type: Boolean, default: false }) readonly fullWidthTrigger!: boolean;
    @Prop({ type: Boolean, default: false }) readonly withoutIcon!: boolean;

    modalShown: boolean = false;

    get isIconShown(): boolean {
      return this.variant !== "linkButton";
    }

    showModal(): void {
      this.modalShown = true;
    }

    closeModal(): void {
      this.modalShown = false;
    }

    onActivityAdded(): void {
      this.$emit('activityAdded');
      this.closeModal();
    }
  }
